import React from 'react'
import TerritorySkinFormPage from './TerritorySkinFormPage'

export default function NewAppTerritorySkin() {
    return <TerritorySkinFormPage mode="create" />
}
